import text from "schemas/elements/text.json";
import textarea from "schemas/elements/textarea.json";
import select from "schemas/elements/select.json";
import radio from "schemas/elements/radio.json";
import checkbox from "schemas/elements/checkbox.json";
import date from "schemas/elements/date.json";
import reference from "schemas/elements/reference.json";
import lookup from "schemas/elements/lookup.json";
import panel from "schemas/elements/panel.json";
import paragraph from "schemas/elements/paragraph.json";
import header from "schemas/elements/header.json";
import legacyArrayView from "schemas/elements/legacyArrayView.json";
import multiReferenceView from "schemas/elements/multiReferenceView.json";
import nestedView from "schemas/elements/nestedView.json";
import number from "schemas/elements/number.json";

// combine all individual element schemas into one!
export default {
	...text,
	...textarea,
	...number,
	...select,
	...radio,
	...checkbox,
	...date,
	...reference,
	...lookup,
	...panel,
	...paragraph,
	...header,
	...legacyArrayView,
	...multiReferenceView,
	...nestedView,
};
